import "./index.css";
import A from "./a";
import B from "./b";

const Model: "A" | "B" = "A";

// Do not modify below!
// Do not modify below!
// Do not modify below!
const Element = Model === "A" ? A : B;

export function App() {
	return <Element />;
}

export default App;
